import { useEffect } from 'react';
import { useAuth } from '../auth';
import { refillPoolIfNeeded } from '../offline/poolManager';
import { syncPendingGames } from '../offline/syncManager';

/**
 * Offline pool refill + pending games sync koordinatörü.
 * - Boot'ta çalışır
 * - `online` event'inde çalışır
 * - token değişiminde (login) çalışır
 */
export function OfflineSync() {
  const { token, user, loading } = useAuth();
  const userId = user?.id ?? null;

  useEffect(() => {
    // Auth henüz hydrate olmadan çalışırsa (token her zaman null görünür) havuz
    // anonim biletlerle dolup hedefe ulaşır; auth yüklendiğinde havuz zaten dolu
    // olduğu için giriş yapmış kullanıcıya ait bilet hiç indirilmez ve ilk oyun
    // sync'te owner_mismatch ile karantinaya gider (Codex bulgusu, doğrulandı).
    if (loading) return;

    const run = () => {
      void refillPoolIfNeeded(token, userId);
      void syncPendingGames(token, userId);
    };

    // İlk boot (auth hydrate olduktan sonra)
    run();

    const onOnline = () => run();
    window.addEventListener('online', onOnline);
    return () => window.removeEventListener('online', onOnline);
  }, [token, userId, loading]);

  return null;
}
